// src/index.ts
import MobileRender from "./mobile-render";
export { MobileRender };